import { AnyAction } from 'redux';
import { SET_ALERT, REMOVE_ALERT } from '../types/alert_types';

const initialState = [];

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_ALERT:
      return [...state, payload];
    case REMOVE_ALERT:
      // return state.filter((alert: Alert): void => alert.id !== payload);
      return state.filter((alert) => {
        return alert.id !== payload;
      });
    default:
      return state;
  }
}
